import { Call } from "../../helpers/fetch";
import { types } from "../types";
import { startUILoading, stopUILoading } from "./administrador/ui/ui";

export const startGetCountries = () => {
    return async (dispatch, getState) => {
        let { countries } = getState().global;
        if (countries.length > 0) {
            return;
        }

        dispatch(startUILoading());
        const resp = await Call("services/maps/countries/show", "GET");
        if (resp.success) {
            const data = resp.success;
            dispatch(showCountries(data));
        }
        dispatch(stopUILoading());
    };
};

export const startGetStateByCountry = (country, formSection) => {
    return async (dispatch) => {
        if (isNaN(country)) {
            return;
        }

        // dispatch(startUILoading());
        const resp = await Call(`services/maps/city/${country}`, "GET");
        if (resp.success) {
            const data = resp.success;

            switch (formSection) {
                case "birth":
                    dispatch(showStatesBirth(data));
                    break;
                case "residence":
                    dispatch(showStatesResidence(data));
                    break;
                case "birthTutor":
                    dispatch(showStatesBirthTutor(data));
                    break;
                case "location":
                    dispatch(showStatesLocation(data));
                    break;
            }
        }
        // dispatch(stopUILoading());
    };
};

const showCountries = (countries) => ({
    type: types.setCountries,
    payload: countries,
});

const showStatesBirth = (states) => ({
    type: types.setStatesBirth,
    payload: states,
});

const showStatesBirthTutor = (states) => ({
    type: types.setStatesBirthTutor,
    payload: states,
});

const showStatesLocation = (states) => ({
    type: types.setStatesLocation,
    payload: states,
});

const showStatesResidence = (states) => ({
    type: types.setStatesResidence,
    payload: states,
});

export const setShowPrintButton = (value) => ({
    type: types.setShowPrintButton,
    payload: value,
});
